module.exports = __webpack_public_path__ + "img/logo2.5ffd89a4.png";